// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsuranceContracts-module__icon--bV59c>svg {
    font-size: 14px;
}

.InsuranceContracts-module__icon--bV59c {
    display: flex
}

.InsuranceContracts-module__ProductName--NO2V0 {
    margin-top: 20px;
    margin-bottom: 20px;
}

.InsuranceContracts-module__btnContainer--O6FGC {
    display: flex;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/insurance-contracts/InsuranceContracts.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".icon>svg {\r\n    font-size: 14px;\r\n}\r\n\r\n.icon {\r\n    display: flex\r\n}\r\n\r\n.ProductName {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.btnContainer {\r\n    display: flex;\r\n    margin-top: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `InsuranceContracts-module__icon--bV59c`,
	"ProductName": `InsuranceContracts-module__ProductName--NO2V0`,
	"btnContainer": `InsuranceContracts-module__btnContainer--O6FGC`
};
export default ___CSS_LOADER_EXPORT___;
